import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const Info = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5229 22 12C22 6.47717 17.5228 2.00002 12 2.00002C6.47715 2.00002 2 6.47717 2 12C2 17.5229 6.47715 22 12 22Z" fill="#FDFDFD" stroke="#808C92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 16V12" stroke="#808C92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 8.00002H12.01" stroke="#808C92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}

export default Info;